import { render, staticRenderFns } from "./member_modal_address1.vue?vue&type=template&id=24fa2b78&"
import script from "./member_modal_address1.vue?vue&type=script&lang=js&"
export * from "./member_modal_address1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports